import { render } from "./page-tree.vue?vue&type=template&id=264473e8&scoped=true"
import script from "./page-tree.vue?vue&type=script&lang=js"
export * from "./page-tree.vue?vue&type=script&lang=js"

import "./page-tree.vue?vue&type=style&index=0&id=264473e8&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264473e8"]])

export default __exports__